import Directory from './Directory';
import File from './File';

export default function List({
  className,
  items,
  selectedFile,
  setIsEditorVisible,
  setSelectedFile,
  solution,
}) {
  return (
    <ul className={className}>
      {items?.map((item) => (
        <li key={item.name}>
          {item.type === 'file' ? (
            <File
              file={item}
              selectedFile={selectedFile}
              setIsEditorVisible={setIsEditorVisible}
              setSelectedFile={setSelectedFile}
            />
          ) : (
            <Directory
              directory={item}
              selectedFile={selectedFile}
              setIsEditorVisible={setIsEditorVisible}
              setSelectedFile={setSelectedFile}
              solution={solution}
            />
          )}
        </li>
      ))}
    </ul>
  );
}
